import { useContext, useEffect, useRef, useState } from 'react';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Item from '../../../../components/Lists/Item';
import { NavBar } from '../../../../components/NavBar/NavBar';
import { SortingButton } from '../../../../components/Sorting/SortingButton';
import { SortingHeader } from '../../../../components/Sorting/SortingHeader';
import { SortingProvider } from '../../../../contexts/SortingContext';
import './EngineeringTask.scss';
import Input from '../../../../components/Inputs/Input';

import { useDispatch, useSelector } from 'react-redux';
import Filters from '../../../../components/Filters/Filters';
import { FiltersManager } from '../../../../components/FiltersManager/FiltersManager';
import { GeneralCard } from '../../../../components/Cards/GeneralCard';
import PackageWarning from '../../../../assets/Images/package-warning.png';
import { DialogContext } from '../../../../contexts/DialogContext';
import { DiscrepancyItemChatModal } from '../../../SupplyChainModules/Components/Discrepancy/DiscrepancyItemChatModal/DiscrepancyItemChatModal';
import { fetchDiscrepancies, fetchDiscrepancyTypes, selectDiscrepancyTypes, selectVendorDiscrepancies } from '../../../../redux/features/VendorModule/VendorDiscrepancy/VendorDiscrepancy';
import BasicDatePicker from '../../../../components/Datepicker/Datepicker';
import { connectSocket } from '../../../../Sockets/socketsConnection';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import { Radios } from '../../../../components/RadioGroup/Radios';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import { ScheduleDialog } from './ScheduleDialog';
import { DropdownsContext, DropdownsProvider, useDropdownConfig } from '../../../../contexts/DropdownsContext';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { EtContext, EtProvider } from '../../contexts/EtContext';
import { EtItemContext, EtItemProvider } from '../../contexts/EtItemContext';
import { Skeleton } from '@mui/material';
import { LABELS } from '../../../../globals/globals';
import { AtaDialog } from './AtaDialog';

const mockDataDis = [
    { engineeringTask: "2025-017", description: "Replace forward cargo door", category: "AD (Airworthiness directive)", subCategory: "AirFrame", type: "RPR (Replacement)", requirementType: "Mandatory", issuedBy: "FAA", issuedDate: "2024-04-01", revisionDate: "2025-05-10", ATA: "12-11-45" }
]

const reasonDiscrepancy = "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos."

const StatusTag = (item, key) => {
    return (
        <button
            className={`ellipsis item-status-tag item-status-tag-${item[key] == "Pending Review"
                ? "orange"
                : item[key] == "Reviewed"
                    ? "purple"
                    : item[key] == "Confirmed"
                        ? "green"
                        : item[key] == "Resolution Provided"
                            ? "blue"
                            : item[key] == "Sent to Vendor"
                                ? "orange"
                                : "red"
                }`}
        >
            {item[key] || "--"}
        </button>
    )

}

const saveButtons = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];


const EngineeringTask = ({ }) => {


    // const { successMsg } = useSnackBar();
    // const [tempResolved, setTempResolved] = useState(false);
    const [filtersOpen, setFiltersOpen] = useState(false);
    // const discrepancies = useSelector(selectVendorDiscrepancies);
    // const discrepancyTypes = useSelector(selectDiscrepancyTypes);
    // const { openDialog, closeDialog } = useContext(DialogContext);
    const dispatch = useDispatch();
    const onFiltersChange = () => { };


    // const openChatDialog = (discrId) => {
    //     openDialog({
    //         component: DiscrepancyItemChatModal,
    //         props: {
    //             onClose: closeDialog,
    //             discrepancyId: discrId,
    //             titleChat: "Supply Chain",
    //             channel: "vendor"
    //         },
    //     });
    // };

    useEffect(() => {
        console.warn('useeffect');
        // dispatch(fetchDiscrepancyTypes({}));
        // dispatch(fetchDiscrepancies({ companyId: localStorage.getItem("u_company_id") }));
        // connectSocket();
        // getVendorDiscrepancies(localStorage.getItem("u_company_id")).then(response => {
        //     console.warn('discrepancies response', response);
        // });
    }, []);



    return (
        <EtProvider>
            <DropdownsProvider>

                <SortingContainer>
                    <div className='engineering-task-component'>
                        <NavBar dataBreadCrumbs="/configuration/engineering-task" moduleId={3} isLocalSearch searchActions={<><SortingButton></SortingButton>
                            <FiltersManager onButtonClick={() => setFiltersOpen((prev) => !prev)} />
                        </>} screenActions={<> <button className="filled iconTextButton">
                            <span>+</span> <span>New ET</span>
                        </button></>} />
                        <div className='v-app-content'>
                            <Filters
                                extOpen={filtersOpen}
                                openChange={(value) => setFiltersOpen(value)}
                                onApplyFilters={onFiltersChange}
                                hideToggle
                                dropdownIds={[1, 2, 3]}
                                hideATA
                            />
                            {/* <div className='filters'>
                        <Dropdowns />
                    </div> */}
                            <SortingHeader></SortingHeader>
                            {/* {JSON.stringify(Object.keys(discrepancies[0] ?? {}))} */}
                            <EtList />
                        </div>

                    </div>
                </SortingContainer >
            </DropdownsProvider>
        </EtProvider>


    )

}

const EtList = () => {

    const { items } = useContext(EtContext);

    return (<>
        {/* {JSON.stringify(items)} */}
        {items?.map((item, idx) => <EtItem discr={item} idx={idx} />)}
    </>
    )
}

const EtItemContent = ({ itemId, discr }) => {

    const { item, itemStatus, startEditing, scheduleStatus, refStatus, startEditSchedule, startEditRef } = useContext(EtItemContext);

    const etPriorityDrpdwn = useDropdownConfig(145);
    const etCategory = useDropdownConfig(146);
    const etSubCategory = useDropdownConfig(147);
    const etType = useDropdownConfig(148);
    const etReqType = useDropdownConfig(149);
    const etIssuers = useDropdownConfig(150);
    const weightBalance = useDropdownConfig(151);
    const etDropdown = useDropdownConfig(50);
    const ataChapter = useDropdownConfig(8);
    const ataSection = useDropdownConfig(9);
    const ataParagraph = useDropdownConfig(10);
    const engDoc = useDropdownConfig(153);
    const engDocLeg = useDropdownConfig(154);
    const mip = useDropdownConfig(155);
    const aircraftArea = useDropdownConfig(156);

    let enabled = [LABELS.DRAFT, LABELS.EDITION_MODE].includes(itemStatus);
    let schEnabled = [LABELS.DRAFT, LABELS.EDITION_MODE].includes(scheduleStatus);
    let refEnabled = [LABELS.DRAFT, LABELS.EDITION_MODE].includes(refStatus);

    return (
        <div className='item-content'>
            <GeneralCard title={<div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between" }}>

                <b>General Information</b>
                {(enabled) ?
                    <MultioptionButton buttons={saveButtons} />
                    :
                    <button onClick={() => startEditing()} className='outlined iconTextButton small-size'>
                        <i className='icon-edit'></i>
                        <span>Edit</span>
                    </button>
                }
            </div>
            } >
                {item ?
                    <div className='general-info-container'>

                        <div className='general-info-grid'>
                            <Input disabled={!enabled} label="ET" value={item.etNumber} />


                            {/* <Input label="ET Priority" value={"High" || "--"} /> */}
                            <Dropdowns disabled={!enabled} preSelectValue={item.priority} optionLabel="name" data={etPriorityDrpdwn.config} />
                            <Input disabled={!enabled} label="Description" value={item.description} />

                            {/* <Input label="Category" value={discr.category || "--"} /> */}
                            <Dropdowns disabled={!enabled} preSelectValue={item.categoryId} optionLabel="name" data={etCategory.config} />
                            <Dropdowns disabled={!enabled} preSelectValue={item.subCategoryId} optionLabel="name" data={etSubCategory.config} />
                            <Dropdowns disabled={!enabled} preSelectValue={item.typeId} optionLabel="name" data={etType.config} />
                            <Dropdowns disabled={!enabled} preSelectValue={item.requirementType.toLowerCase()} optionLabel="name" data={etReqType.config} />
                            <Dropdowns disabled={!enabled} preSelectValue={item.issuedById} optionLabel="name" data={etIssuers.config} />
                            {/* <Input label="Sub Category" value={discr.subCategory || "--"} /> */}
                            {/* <Input label="Rquirement Type" value={discr.requirementType || "--"} /> */}
                            {/* <Input label="Issued By" value={discr.issuedBy || "--"} /> */}

                            {/* <BasicDatePicker label="Revision Date" value={discr.revisionDate || "--"} />
                        <BasicDatePicker label="Issued Date" value={discr.issuedDate || "--"} /> */}
                            <Input disabled={!enabled} label="Revision Date" value={item.revisionDate?.slice(0, 10) || ""} />
                            <Input disabled={!enabled} label="Issued Date" value={item.issuedDate?.slice(0, 10) || ""} />
                            <Dropdowns disabled={!enabled} preSelectValue={item.supersededEtId} overrideLabel="SuperSeded ET" optionLabel="name" data={etDropdown.config} />
                            {/* <Input label="SuperSeded ET" value={"ET-2023-089" || "--"} /> */}
                            <Input disabled={!enabled} label="SuperSeded Date" value={item.issuedDate?.slice(0, 10) || ""} />
                            <Input disabled={!enabled} label="WP Phase" value={item.wpPhase} />
                        </div>
                        <div className='ata-container'>
                            <div className='inputs-container'>
                                <b>ATA</b>
                                <div className="inputs">
                                    {/* <Input label="Chapter" value="12" /> */}
                                    <Dropdowns disabled={!enabled} data={ataChapter.config} />
                                    <Dropdowns disabled={!enabled} data={ataSection.config} />
                                    <Dropdowns disabled={!enabled} data={ataParagraph.config} />
                                    {/* <Input label="Section" value="11" />
                            <Input label="Paragraph" value="45" /> */}
                                </div>
                                <i>Clear</i>
                            </div>
                          

                            <DialogTrigger dialogContent={{ component: AtaDialog, props: {} }} >
                                <button className='filled small-size'>
                                    + Add More ATA
                                </button>
                                {/* <div class="more-options-container "><span><i class="icon-more-horizontal"></i></span></div> */}
                            </DialogTrigger>

                        </div>

                    </div>
                    :
                    <>
                        <Skeleton height="3rem" />
                    </>
                }


            </GeneralCard>
            <GeneralCard title={<div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between" }} className='gschedule-title'>

                <b>General Schedule</b>
                {(schEnabled) ?
                    <MultioptionButton buttons={saveButtons} />
                    :
                    <button onClick={() => startEditSchedule()} className='outlined iconTextButton small-size'>
                        <i className='icon-edit'></i>
                        <span>Edit</span>
                    </button>
                }
                {/* <button className='filled small-size iconTextButton'>+ Add ATA</button> */}
            </div>}>

                <div className='gschedule-content'>
                    <div className='repeat-n-date'>
                        <div className='repeat-container'>
                            <div className='checks'>
                                <CheckboxField disabled={!schEnabled} checked={true}>Repeat</CheckboxField>
                                <CheckboxField disabled={!schEnabled} checked={false}>Unlimited</CheckboxField>
                            </div>

                            <Input disabled={!schEnabled} label="Repeat Number"></Input>

                        </div>
                        <div className='schedule-container'>
                            <div className='schedule-date'>
                                <b>Schedule Date</b>
                                {/* <BasicDatePicker label=""   value="2024-12-30"/> */}
                                <Input disabled={!schEnabled} label="" value="2024-12-30" />
                            </div>

                            <DialogTrigger dialogContent={{ component: ScheduleDialog, props: {} }} >
                                <button className='filled small-size'>
                                    Aircraft and PNs
                                </button>
                                {/* <div class="more-options-container "><span><i class="icon-more-horizontal"></i></span></div> */}
                            </DialogTrigger>

                        </div>

                    </div>



                    <div className='sub-card threshold'>
                        <b>Threshold</b>
                        <Input disabled={!schEnabled} label="Hours" fixedLabel centerLabel />
                        <Input disabled={!schEnabled} label="Cycles" fixedLabel centerLabel />
                        <Input disabled={!schEnabled} label="Days" fixedLabel centerLabel />
                        <Input disabled={!schEnabled} label="Total Hours" fixedLabel centerLabel />
                        <Input disabled={!schEnabled} label="Total Cycles" fixedLabel centerLabel />
                        <Input disabled={!schEnabled} label="Total Days" fixedLabel centerLabel />

                    </div>

                    <div className='sub-card interval'>
                        <b>Interval</b>
                        <Input disabled={!schEnabled} label="Hours" fixedLabel centerLabel />
                        <Input disabled={!schEnabled} label="Cycles" fixedLabel centerLabel />
                        <Input disabled={!schEnabled} label="Days" fixedLabel centerLabel />
                    </div>



                </div>
            </GeneralCard>
            {/* <GeneralCard title={
                                    <b>ATA</b>} >
                                    <div className='discr-info-grid'>
                                        <Input label="Discrepancy Category" disabled value={discrType ?? "--"} />

                                        {(discrType == "Incorrect Quantity" || discrType == "Incorrect QTY") ? (
                                            <div className='subform'>
                                                <div>
                                                    <span>Requested QTY</span>
                                                    <Input label="" disabled value={discr.quantity} />

                                                </div>
                                                <div>
                                                    <span>Received QTY</span>
                                                    <Input label="" disabled value={discr.discrepancyQuantity} />
                                                </div>
                                                <div>
                                                    <span>UOM</span>
                                                    <Input label="" disabled value={discr.uom} />
                                                </div>
                                            </div>
                                        ) : discrType == "PN Does Not Exist" ? (
                                            <Input
                                                label={"Part Number (PN)"}
                                                value={discr.discrenpancyPartNumber || "--"}
                                                disabled={true}
                                            ></Input>
                                        ) : discrType == "Expired Shelf Life" ? (
                                            <BasicDatePicker
                                                label={"Shelf Life"}
                                                name={"shelfLife"}
                                                value={discr.discrepancyShelfLife || "--"}
                                                disabled={true}
                                            ></BasicDatePicker>
                                        ) : discrType == "Wrong PN" ? (
                                            <Input
                                                label={"Part Number (PN)"}
                                                value={discr.discrenpancyPartNumber || "--"}
                                                disabled={true}
                                            ></Input>
                                        ) : <b></b>}
                                        <Input multiLine label="Reason Description" disabled value={discr.discrepancyDescription || "--"} />
                                    </div>
                                </GeneralCard> */}
            {/* <div className='thrd-col'> */}
            <GeneralCard title={<div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between" }} className='gschedule-title'>

                <b>References</b>
                {(refEnabled) ?
                    <MultioptionButton buttons={saveButtons} />
                    :
                    <button onClick={() => startEditRef()} className='outlined iconTextButton small-size'>
                        <i className='icon-edit'></i>
                        <span>Edit</span>
                    </button>
                }

                {/* <button className='filled small-size iconTextButton'>+ Add ATA</button> */}
            </div>
            } >
                <div className='ref-container'>
                    {/* <Input label="Engineering Document" value="ENG-2024-0098" /> */}
                    <Dropdowns disabled={!refEnabled} optionLabel="name" data={engDoc.config} isStatic />
                    <Dropdowns disabled={!refEnabled} optionLabel="name" data={engDocLeg.config} isStatic />
                    <Dropdowns disabled={!refEnabled} optionLabel="name" data={mip.config} isStatic />

                    {/* <Input label="Engineering Document Legacy" value="LEGACY ENG-2024-0098" /> */}
                    {/* <Input label="Maintenance Inspection Program" value="LEGACY ENG-2024-0098" /> */}
                    {/* <Input label="Conflicting Engineering Task" value="ENG-2023-0111" /> */}
                    <Dropdowns disabled={!refEnabled} overrideLabel="Conflicting Engineering Task" optionLabel="name" data={etDropdown.config} />

                    <Input disabled={!refEnabled} label="Mod Number" value="MOD 1456" />
                    {/* <Input label="Aircraft Area" value="FWD Cargo Compartment" /> */}
                    <Dropdowns disabled={!refEnabled} optionLabel="name" data={aircraftArea.config} isStatic />

                    <Input disabled={!refEnabled} label="MRB" value="MRB Task 27-51-00-200-001" />
                </div>
            </GeneralCard>
            {/* <div className='schedule-card general-card-component'>
                    <DialogTrigger dialogContent={{ component: ScheduleDialog, props: {} }} >

                        <div class="more-options-container "><span><i class="icon-more-horizontal"></i></span></div>
                    </DialogTrigger>
                    <b>Schedule Information</b>
                    <div className='pn-indicator'>
                        <b>General Schedule</b>
                        <span className='pn-count'>
                            <b>PN</b>
                            <i>2</i>
                        </span>

                    </div>

                </div> */}


            {/* </div> */}
            <div className='technical general-card-component'>
                <b>Technical</b>
                <Dropdowns optionLabel="name" data={weightBalance.config} />
                <b>Weight Change +/-</b>
                <Input label="" isNumeric value="0.5" />
                <b>Kg</b>
                <CheckboxField checked={true}>Electrical Load Change</CheckboxField>
                <CheckboxField checked={true}>Certification Maintenance Requirement</CheckboxField>
                <Radios onChange={(newV) => { }} value={false} name="fixed" items={[{ value: false, label: "Repair" }, { value: true, label: "Alteration" }]} />


            </div>


        </div>
    )


}

const EtItem = ({ discr, idx }) => {




    return (<Expandable2 summary={<>
        {/* {JSON.stringify(discr)} */}

        <Item valuePlaceholder="--" orderedProperties={['etNumber', 'description', 'categoryName', 'subCategoryName', 'typeName', 'requirement_type', 'issuedBy', 'issued_date', 'revision_date', 'ATA']} lightFont hideLabels key={discr} item={discr} renderProperty={{ status: StatusTag }}>
            {/* <Item renderProperty={{ "orderType": OrderType, "daysSince": Hlght }} ignoreProperties={["id", "status"]} lightFont hideLabels key={discr} item={discr}> */}

        </Item></>}>
        <EtItemProvider itemId={discr.id}>
            <EtItemContent discr={discr}>

            </EtItemContent>
        </EtItemProvider>

    </Expandable2>)
}

const SortingContainer = ({ children }) => {
    const dropdownIds = [145, 146, 147, 148, 149, 150, 50, 151, 8, 9, 10, 153, 154, 155, 156, 29, 114];
    const { setDropdownIds } = useContext(DropdownsContext);
    useEffect(() => {
        setDropdownIds(dropdownIds);
    }, []);

    return (
        <SortingProvider properties={
            { engineeringTask: "ET", description: "Description", category: "Category", subCategory: "Sub Category", type: "Type", requirementType: "Requirement Type", issuedBy: "Issued By", issuedDate: "Issued Date", revisionDate: "Revision Date", ATA: "ATA" }

        }>


            {/* <DropdownsProvider> */}
            {children}
            {/* </DropdownsProvider> */}
        </SortingProvider>
    )

}
export default EngineeringTask;